import { memo } from "react";
import { Handle, Position, type NodeProps } from "@xyflow/react";
import type { TextFlowNode } from "./node-types.js";
import { useMeasuredHandles } from "./useMeasuredHandles.js";
import { canvasCopy } from "../../copy/zh-CN.js";
import { InlineTextEditor, CanvasPromptEditor } from "./InlineTextEditor.js";

export const TextNode = memo(function TextNode({
  id,
  data,
  selected
}: NodeProps<TextFlowNode>) {
  useMeasuredHandles(id, data.refreshHandles);
  return (
    <article className={`asset-node asset-node--text${selected ? " asset-node--selected" : ""}`}>
      <Handle type="target" position={Position.Left} aria-label="接收文本连线" />
      <header><span>{canvasCopy.textNode}</span></header>
      {data.document && data.onDocumentChange ? <CanvasPromptEditor document={data.document} source={{nodeId:id,field:"text",inputEdgeId:null}} onChange={data.onDocumentChange} ariaLabel="直接编辑文本" maxLength={50_000} {...(data.onUndo ? {onUndo:data.onUndo} : {})} {...(data.onRedo ? {onRedo:data.onRedo} : {})} /> : <InlineTextEditor
        value={data.canvasNode.text}
        onChange={(text) => data.onTextChange?.(id, text)}
      />}
      <Handle type="source" position={Position.Right} aria-label="从文本节点拉出连线" />
    </article>
  );
});
